import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TemplatesService } from './templates.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AddProposalService } from '../proposals/add-proposal/add-proposal.service';

@Component({
    selector: 'app-update-template',
    templateUrl: './app-update-template.html',
    styleUrls: ['./templates.component.css']
})
export class UpdateTemplateModal implements OnInit {

    constructor(
        private router: Router,
        public dialog: MatDialog,
        private _service: TemplatesService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<UpdateTemplateModal>,
        private _proposalService: AddProposalService,
        private toastr: ToastrService
    ) { }
    private unsubscribe = new Subject<void>();
    allCategories: any;
    categoryId: any;
    subCategoryId: any;
    templateId: any;
    subTemplateId: any;
    newSharepointId: any;
    categoryName: any;
    subCategoryName: any;
    templateName: any;
    subTemplateName: any;
    subCategories: any;
    templates: any;
    subTemplates: any;
    templateSharepointId: any;
    subTemplateSharepointId: any;
    categorySharepointId: any;
    subCategorySharepointId: any;
    ngOnInit() {
        this.templateId = this.data.length == 1 && this.data[0].templateId ? this.data[0].templateId : 0;
        this.subTemplateId = this.data.length == 1 && this.data[0].subCategoryTemplateId ? this.data[0].subCategoryTemplateId : 0;
        this.getTemplates();
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    categoryChange(event) {
        this.subCategories = null;
        let value = event.target.value;
        if (value != "0") {
            this.categoryId = Number(value)
            this.categoryName = this.allCategories.find(({ id }) => id === parseInt(value)).name;
            this.categorySharepointId = this.allCategories.find(({ id }) => id === parseInt(value)).sharepointId
            this.getSubCategories(this.categoryId);
        }
        else {
            this.categoryName = null
            this.categorySharepointId = null
            this.categoryId = 0
            this.subCategoryName = null
            this.subCategorySharepointId = null
        }
    }

    subCategoryChange(event) {
        let value = event.target.value;
        if (value != "0") {
            this.subCategoryId = Number(value)
            this.subCategoryName = this.subCategories.find(({ id }) => id === parseInt(value)).name
            this.subCategorySharepointId = this.subCategories.find(({ id }) => id === parseInt(value)).sharepointId
        }
        else {
            this.subCategoryName = null
            this.subCategorySharepointId = null
        }
    }


    templateChange(event) {
        this.subTemplates = null;
        let value = event.value;
        if (value != "0") {

            this.templateId = Number(value)
            this.templateName = this.templates.find(({ id }) => id === parseInt(value)).category
            this.templateSharepointId = this.templates.find(({ id }) => id === parseInt(value)).sharepointId
            this.subTemplateId = 0;
            this.getSubTemplates(this.templateId);
        }
        else {
            this.templateId = 0
            this.templateName = null
            this.templateSharepointId = null
            this.subTemplateId = 0
            this.subTemplateName = null
            this.subTemplateSharepointId = null
        }
    }

    subTemplateChange(event) {
        let value = event.value;
        if (value != "0") {
            this.subTemplateId = Number(value)
            this.subTemplateName = this.subTemplates.find(({ id }) => id === parseInt(value)).subCategory;
            this.subTemplateSharepointId = this.subTemplates.find(({ id }) => id === parseInt(value)).sharepointId;
            }
        else {
            this.subTemplateId = 0
            this.subTemplateName = null
            this.subTemplateSharepointId = null
        }
    }

    getCompetencies(templateId, subTemplateId) {
        this._proposalService.getCompetencies(templateId, subTemplateId).subscribe((res) => {
            this.allCategories = res.data;
        })
    }

    getSubCategories(categoryId) {
        this.subCategories = this.allCategories.find(({ id }) => id === parseInt(categoryId)).subCompetencies
    }

    getTemplates() {
        this._proposalService.getTemplatesDropdown().subscribe((res) => {
            this.templates = res.data;
        })
    }

    getSubTemplates(id: number) {
        this._proposalService.getSubTemplatesDropdown(id).subscribe((res) => {
            this.subTemplates = res.data
        })
    }

    moveToFolder() {
        if (this.templateId && this.subTemplateId) {
            this.newSharepointId = this.subTemplateSharepointId
            if (this.categorySharepointId != null) {
                this.newSharepointId = this.categorySharepointId
            }
            if (this.subCategorySharepointId != null) {
                this.newSharepointId = this.subCategorySharepointId
            }
            if (this.data.type == 'Bulk') {
                let attachments = this.data.values[0].map(item => {
                    return {
                        'id': item.id,
                        'name': item.name,
                        'sharePointId': item.sharepointId,
                    };
                })
                let attacmentList = []
                for (let i = 0; i < attachments.length; i++) {
                    attacmentList.push(attachments[i])
                }
                let templates = {
                    
                    'attachments': attacmentList,
                    'sharepointFolderId': this.newSharepointId,
                    'categoryId': this.categoryId,
                    'categoryName': this.categoryName,
                    'subCategoryId': this.subCategoryId,
                    'subCategoryName': this.subCategoryName,
                    'templateId': this.templateId,
                    'templateName': this.templateName,
                    'subTemplateId': this.subTemplateId,
                    'newCategoryId': this.categoryId,
                    'subCategoryTemplate': this.subTemplateName,
                    }
                this._service.MoveTemplatesInBulk(templates).subscribe(x => {
                    this.dialogRef.close(templates);
                    this.toastr.success("Successfully moved");
                })
            }
            else {
                this._service.moveToFolder(this.data.values[0].id, this.newSharepointId, this.templateId, this.templateName,
                    this.subTemplateId, this.subTemplateName).subscribe(x => {
                        this.dialogRef.close(true);
                        this.toastr.success("Successfully moved");
                    })
            }
        }
        else if (!this.templateId) {
            this.toastr.error("Select Artifactory Category");
        }
        else if (!this.subTemplateId) {
            this.toastr.error("Select Artifactory Category Type");
        }
    }

    getDownloadCount() {
        let count = 0;
        this.data.values.map(i => {
            count = count + i.downloadCount
        })
        return count;
    }
    closeDialog(status) {
        this.dialogRef.close(status)
    }
}




